module.exports = __webpack_public_path__ + "static/media/Chalet-NewYorkSixty.548639ec.woff";